<template>
  <div>
    <template v-if="orderDetails.fulfillmentType === 'delivery'">
      <h3 class="title title--6 half-spacing">
        Delivered To
      </h3>

      <div class="layout layout--horizontal layout--horizontal-less-space">
        <div class="grow">
          <div class="layout layout--icon">
            <span class="icon far fa-car dark-gray" />

            <div>
              <p
                v-if="orderDetails.deliveryAddress.type"
                class="dark bold no-spacing"
              >
                {{ orderDetails.deliveryAddress.type }}
              </p>

              <p class="dark">
                {{ orderDetails.deliveryAddress.line1 }},

                <template v-if="orderDetails.deliveryAddress.line2">
                  {{ orderDetails.deliveryAddress.line2 }},
                </template>

                <span class="no-wrap">
                  {{ orderDetails.deliveryAddress.city }},
                  {{ orderDetails.deliveryAddress.state }}
                  {{ orderDetails.deliveryAddress.postalCode }}
                </span>
              </p>
            </div>
          </div>
        </div>

        <button
          v-if="orderDetails.orderType !== 'group'"
          class="button button--light button--light-text button--icon button--small"
          type="button"
          title="Change Delivery Address"
          @click="$openModal('editOrderDetails')"
        >
          <span class="icon far fa-pencil-alt" />
        </button>
      </div>
    </template>

    <template v-else-if="orderDetails.fulfillmentType === 'shipping'">
      <h3 class="title title--6 half-spacing">
        Shipping To
      </h3>

      <div class="layout layout--horizontal layout--horizontal-less-space">
        <div class="grow">
          <div class="layout layout--icon">
            <span class="icon far fa-truck dark-gray" />

            <div>
              <p
                v-if="orderDetails.deliveryAddress.type"
                class="dark bold no-spacing"
              >
                {{ orderDetails.deliveryAddress.type }}
              </p>

              <p
                v-if="orderDetails.deliveryAddress.addressee"
                class="dark no-spacing"
              >
                {{ orderDetails.deliveryAddress.addressee }}
              </p>

              <p class="dark">
                {{ orderDetails.deliveryAddress.line1 }},

                <template v-if="orderDetails.deliveryAddress.line2">
                  {{ orderDetails.deliveryAddress.line2 }},
                </template>

                <span class="no-wrap">
                  {{ orderDetails.deliveryAddress.city }},
                  {{ orderDetails.deliveryAddress.state }}
                  {{ orderDetails.deliveryAddress.postalCode }}
                </span>
              </p>
            </div>
          </div>
        </div>

        <button
          v-if="orderDetails.orderType !== 'group'"
          class="button button--light button--light-text button--icon button--small"
          type="button"
          title="Change Shipping Address"
          @click="$openModal('editOrderDetails')"
        >
          <span class="icon far fa-pencil-alt" />
        </button>
      </div>
    </template>

    <template v-else>
      <slot name="pick-up-title">
        <h3 class="title title--6 half-spacing">
          <template v-if="orderDetails.fulfillmentType === 'room-service'">
            Room Service
          </template>
          <template v-else>
            Pick Up At
          </template>
        </h3>
      </slot>

      <div class="layout layout--horizontal layout--horizontal-less-space">
        <div class="grow">
          <div class="layout layout--icon">
            <span class="icon fa-map-marker-alt dark-gray" />

            <div>
              <p class="dark bold no-spacing no-wrap-ellipsis">
                {{ selectedLocation.description }}
              </p>

              <p class="dark no-wrap-ellipsis">
                {{ selectedLocation.address.line1 }},
                {{ selectedLocation.address.city }},
                {{ selectedLocation.address.state }}
                {{ selectedLocation.address.postalCode }}
              </p>
            </div>
          </div>

          <div
            v-if="displayRoomNumber"
            class="layout layout--icon"
          >
            <span class="icon far fa-door-closed dark-gray" />

            <div>
              <p class="dark bold no-spacing no-wrap-ellipsis">
                Room Number
              </p>

              <p class="dark no-wrap-ellipsis">
                {{ tableNumberDisplay }}
              </p>
            </div>
          </div>
        </div>

        <template v-if="orderDetails.fulfillmentType !== 'room-service'">
          <directions-button
            class="button button--light button--light-text button--icon button--small"
            :location="selectedLocation"
          >
            <span class="icon far fa-directions" />
            <span class="ada-text">Get Directions</span>
          </directions-button>

          <button
            v-if="orderDetails.orderType !== 'group'"
            class="button button--light button--light-text button--icon button--small"
            type="button"
            title="Change Location"
            @click="$openModal('editOrderDetails')"
          >
            <span class="icon far fa-pencil-alt" />

            <span class="ada-text">Change Location</span>
          </button>
        </template>
      </div>
    </template>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'SelectedLocationOrderDetails',

    computed: {
      ...mapGetters('locations', ['selectedLocation']),
      ...mapGetters('session', ['orderDetails']),
      ...mapGetters('orders', ['tableNumberDisplay']),

      displayRoomNumber() {
        /** Display the user's room number if tableNumberDisplay (ie. table number exists in url) */
        return this.orderDetails.fulfillmentType === 'room-service' && this.tableNumberDisplay;
      }
    }
  };
</script>
